import React from 'react';
import { Link } from 'react-router-dom';

const renderButtonContents = children => (
<>
  <span className="button-secondary__label df jcc aic w100% h100% posa g4@md">
    { children }
    <span className="button-secondary__label-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7.757 18.4139C8.13206 18.7889 8.64067 18.9995 9.171 18.9995C9.70133 18.9995 10.2099 18.7889 10.585 18.4139L17 11.9999L10.585 5.58594C10.195 5.19494 9.683 4.99994 9.171 4.99994C8.659 4.99994 8.147 5.19494 7.757 5.58594C7.38206 5.96099 7.17143 6.46961 7.17143 6.99994C7.17143 7.53027 7.38206 8.03888 7.757 8.41394L11.342 11.9999L7.757 15.5859C7.38206 15.961 7.17143 16.4696 7.17143 16.9999C7.17143 17.5303 7.38206 18.0389 7.757 18.4139Z" fill="#7C0D2C"/>
      </svg>
    </span>
  </span>
  <span className="vh" aria-hidden="true">{ children }</span>
</>
)

export default function ButtonSecondary({ className, onClick, buttonType, to, href, children }) {
  const buttonClasses = `button-secondary bd2-s-red bgc-transparent posr fz14@md fz16 h48 bdrs8 df fxdrc aic jcc oh pl24 pr24 curp fw500 ${ className || '' }`;
  return to ? (
    <Link
      className={buttonClasses}
      to={to}
    >
    { renderButtonContents(children) }
    </Link>
    )
  : href ? (
    <a
      className={buttonClasses}
      href={href}
    >
    { renderButtonContents(children) }
    </a>
    )
  : onClick ? (
    <button
      className={buttonClasses}
      type={buttonType || 'button'}
      onClick={onClick}
    >
    { renderButtonContents(children) }
    </button>
    )
  : (
    <span className={buttonClasses}>
    { renderButtonContents(children) }
    </span>
    )
}